$(document).ready(function() {

  //check if this type of page is a shopify product page 
  if ($(".product__info-wrapper").length > 0) {
    $(".accordion-lc").first().addClass("main");
    $(".accordion-lc").first().next().slideToggle();
  }

  $(".accordion-lc").click(function() {
    $(this).next().slideToggle();
  });

  $(".accordion-lc").click(function() {
    $(this).toggleClass("main");
  });

});